import React from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { MONO_FONT } from './ItemCell';

/** Document id (MR-EMB-000072, PO-000572, GRN-000581) in mono with a small line under it: date · age · urgency. */
export interface DocCellProps {
  id: string;
  linkTo?: string;
  date?: string | Date | null;
  /** Extra text after the date, e.g. "Normal" or "3 days". */
  meta?: React.ReactNode;
  compact?: boolean;
}

export function ageLabel(date?: string | Date | null): string | null {
  if (!date) return null;
  const d = dayjs(date).startOf('day');
  const diff = dayjs().startOf('day').diff(d, 'day');
  if (diff === 0) return 'today';
  if (diff === 1) return 'yesterday';
  if (diff > 1) return `${diff} days ago`;
  if (diff === -1) return 'tomorrow';
  return `in ${-diff} days`;
}

const DocCell: React.FC<DocCellProps> = ({ id, linkTo, date, meta, compact }) => {
  const idEl = (
    <span style={{ font: `600 13px/1.3 ${MONO_FONT}`, whiteSpace: 'nowrap', color: linkTo ? '#1e6fe6' : 'inherit' }}>{id}</span>
  );
  return (
    <div style={{ lineHeight: 1.35 }}>
      {linkTo ? <Link to={linkTo}>{idEl}</Link> : idEl}
      {!compact && (date || meta) ? (
        <span style={{ display: 'block', fontSize: 11.5, color: '#8a94a6', whiteSpace: 'nowrap', marginTop: 1 }}>
          {date ? dayjs(date).format('D MMM') : null}
          {date && meta ? ' · ' : null}
          {meta}
        </span>
      ) : null}
    </div>
  );
};

export default DocCell;
